import { LeaderboardCard } from "@/components/LeaderboardCard";
import { StudentRanking, TopSellersPodium, TopCategoryPodium, getCombinedTopStudents } from "@/components/StudentRanking";
import { PopularItem } from "@/components/PopularItem";
import { EmptyState } from "@/components/EmptyState";
import { Sparkles, Package } from "lucide-react";
import { t } from "@/i18n";

export const StudentView = ({ data, period = "week", refreshing, lang = "da" }) => {
  // Robusthed (Opf. #35): hvis data ikke er et forventet objekt (fx fejl-respons),
  // vis EmptyState frem for at crashe til blank side.
  const safe = (data && typeof data === "object" && !Array.isArray(data)) ? data : {};
  const { department_ranking, student_rankings, gavekort_rankings, upgrade_rankings, popular_treatments, popular_products, member_images, min_placering } = safe;
  const isEmpty = !department_ranking || department_ranking.length === 0;

  if (isEmpty) return <EmptyState lang={lang} />;

  // Opfølgning #34 (#4): elevens egen placering pr. kategori (backend-beregnet).
  const mp = min_placering || {};

  const overallTop = getCombinedTopStudents([student_rankings, gavekort_rankings, upgrade_rankings]);

  const PERIOD_SUFFIX = {
    day: lang === "en" ? "today" : "i dag",
    week: lang === "en" ? "this week" : "denne uge",
    month: lang === "en" ? "this month" : "denne måned",
    last_month: lang === "en" ? "last month" : "sidste måned",
    prev_month: lang === "en" ? "previous month" : "forrige måned",
  };
  const periodSuffix = PERIOD_SUFFIX[period] || PERIOD_SUFFIX.week;

  return (
    <div className="space-y-6" data-testid="student-view">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <TopSellersPodium students={overallTop} memberImages={member_images || {}} periodSuffix={periodSuffix} lang={lang} egenPlacering={mp.overall} />
        <LeaderboardCard
          title={t(lang, "deptRankingQty")}
          data={department_ranking}
          showAmounts={false}
          valueKey="total_qty"
          lang={lang}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <TopCategoryPodium title="Gavekort / Klippekort" rankings={gavekort_rankings || {}} memberImages={member_images || {}} periodSuffix={`solgte gavekort/klippekort ${periodSuffix}`} egenPlacering={mp.gavekort} />
        <TopCategoryPodium title="Produktsalg" rankings={student_rankings || {}} memberImages={member_images || {}} periodSuffix={`solgte produkter ${periodSuffix}`} egenPlacering={mp.produkt} />
        <TopCategoryPodium title="Opgraderingsydelser" rankings={upgrade_rankings || {}} memberImages={member_images || {}} periodSuffix={`opgraderinger ${periodSuffix}`} egenPlacering={mp.opgradering} />
      </div>

      <StudentRanking rankings={student_rankings} memberImages={member_images || {}} periodSuffix={periodSuffix} lang={lang} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PopularItem
          title={t(lang, "popularProducts")}
          icon={Package}
          items={popular_products}
          accentColor="#00FF66"
          lang={lang}
        />
        <PopularItem
          title={t(lang, "popularTreatments")}
          icon={Sparkles}
          items={popular_treatments}
          accentColor="#FF2A6D"
          lang={lang}
        />
      </div>
    </div>
  );
};
